import * as React from "react"
import { useIntl } from "react-intl"

import { Card, CardItem } from "@walmart-web/livingdesign-components"
import unexpectedErrorImage from "assets/images/error/unexpected_error.svg"

import "./ErrorMessage.scss"

interface ErrorMessageProps {
	type: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ type }): JSX.Element => {
	const intl = useIntl()

	const className = "reset-password-error"

	return (
		<div className={`${className}`}>
			<Card size="medium" UNSAFE_className={`${className}-card`}>
				<img src={unexpectedErrorImage} aria-hidden alt={""} />
				<CardItem>
					<div className={`${className}-content`}>
						<div className="title">
							<h2>
								{intl.formatMessage({
									id: "phronesis.reset-password.error.title",
								})}
							</h2>
						</div>
						<div>
							<p>
								{intl.formatMessage(
									{
										id: "phronesis.reset-password.error.subtitle",
									},
									{ type, b: (str) => <b>{str}</b> }
								)}
							</p>
						</div>
					</div>
				</CardItem>
			</Card>
		</div>
	)
}

export default ErrorMessage
